import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=1864b858&scoped=true&"
import script from "./restaurant.vue?vue&type=script&lang=js&"
export * from "./restaurant.vue?vue&type=script&lang=js&"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=1864b858&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864b858",
  null
  
)

export default component.exports